import { TabContent, TabPane } from "reactstrap";
import { Image, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { TabContentProp } from "../../../../Type/UiKits";

export const IconTabContent = ({basicTab}:TabContentProp) => {
  return (
    <TabContent activeTab={basicTab}>
      <TabPane tabId="1">
        <P className="pt-3">Not limited to any states, boundaries. All over India providing cutting-edge design and website development services for over 12 years. We provide end to end digital solutions, right from designing your website/application development: Domain, Web Hosting, Email Hosting Registration, Search Engine Optimization and other Internet Marketing, Renewal of Services timely and effectively.</P>
      </TabPane>
      <TabPane tabId="2">
        <div className="pt-3 mb-0">
          <div className="flex-space flex-wrap align-items-center">
            <Image className="tab-img" src={dynamicImage("avtar/7.jpg")} alt="profile" />
            <P><strong>Visit Us: </strong> 278 Green Avenue Oakland, CA 94612<br /><strong>Mail Us:</strong>MichaelMMcGowan@teleworm.us<br /><strong>Contact Number: </strong>510-767-0025</P>
          </div>
        </div>
      </TabPane>
      <TabPane tabId="3">
        <P className="pt-3">Us Technology offers web & mobile development solutions for all industry verticals.Include a short form using fields that'll help your business understand who's contacting them.<br /> <strong>Visit Us: </strong> 2600 Hollywood Blvd,Florida, United States- 33020<br /><strong>Mail Us:</strong>contact@us@gmail.com<br /><strong>Contact Number: </strong>(954) 357-7760</P>
      </TabPane>
    </TabContent>
  );
};
